import React, { useEffect, useMemo, useState } from 'react'
import { Dropdown, Ripple, initMDB } from "mdb-ui-kit";
import { primary_theme_color, secondary_theme_color } from '../../../constants/constants';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { styled } from '@mui/system';
import InputAdornment from '@mui/material/InputAdornment';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Form from 'react-bootstrap/Form';
const StyledFormControl = styled(FormControl)({
    '.MuiOutlinedInput-root': {
        borderRadius: '0.25rem',
    },
    '.MuiOutlinedInput-notchedOutline': {
        borderColor: '#ced4da',
    },
    '.MuiOutlinedInput-input': {
        padding: '0.375rem 2.25rem 0.375rem 0.75rem',
        backgroundColor: '#fff',
        borderRadius: "var(--bs-border-radius)",
    },
    '.MuiSelect-select': {
        minHeight: '0',
    },
});

export default function MDBDropdown(props) {

    const [selectedItem, setSelectedItem] = useState('');
    const handleItemClick = (event) => {
         debugger;   
        console.log(items, event);
//        if (items.value === "10000") return;
        let value = ''; 
//        if (items.length !== 1) {
            event.target.querySelectorAll('option').forEach(item => {
                if (item.selected) {
                    // console.log(item.value+"--->"+item.text);
                    value = item.value;
                }
            });
//        }
       debugger;
        if(value === "10000"){
            value = '';
            return;
        }
        console.log("itemVal" + value+":"+props.keyIdentifier);
        setSelectedItem(value);
        props.onChange(items[value],props.keyIdentifier);
        console.log(items[value]);

    };
    const items = useMemo(() => {
        //debugger;
        return [...props.items].sort((a, b) => a?.desc ? a.desc.localeCompare(b.desc) : a.attributeVal.localeCompare(b.attributeVal));
    }, [props.items]);

    const buttonStyles = {
        backgroundColor: 'white',
        color: secondary_theme_color,
        borderRadius: '8px', // Adding border radius for curved corners
        border: '2px solid' + secondary_theme_color, // Adding a border
        padding: '8px 12px',
        boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
        alignSelf: 'center'
        // Add more styles as needed
    };
    console.log("isDisabled", props.isDisabled);

    useEffect(() => {
        console.log("Hello", props.items);
        //if (items && props.items.length === 1)
        //    handleItemClick(0);

        if (props.rstSwitch) {
            setSelectedItem('');
            props.toggleRstSwitch(!props.rstSwitch);
        }
    }, [
        // handleItemClick
        // , 
        props.items, props.rstSwitch])
    console.log(selectedItem);
    return (
        // <div className="dropdown">
        //     <button
        //         className="btn btn-lg btn-primary dropdown-toggle dropdown-toggle-split"
        //         type="button"
        //         id="dropdownMenuButton"
        //         aria-expanded="true"
        //         data-mdb-dropdown-init=""

        //         style={buttonStyles}
        //         value={selectedItem}

        //     >
        //         {selectedItem || 'Select an option    '}
        //     </button>
        // <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">

        // </ul>
        // </div>

        // <StyledFormControl disabled={props.isDisabled}
        //     sx={{ m: 1, minWidth: 120, width: "-webkit-fill-available" }}
        //     size="small"
        //     required={props.isRequired}>
        //     {/* <InputLabel id="demo-select-small-label">Choose</InputLabel> */}
        //     <Select
        //         labelId="demo-select-small-label"
        //         id="demo-select-large"
        //         value={selectedItem}
        //         variant='outlined'
        //         // label="Choose"
        //         disabled={props.disabled}
        //         onChange={handleItemClick}
        //         // inputProps={{
        //         //     endAdornment: (
        //         //       <InputAdornment position="end">
        //         //         <KeyboardArrowDownIcon />
        //         //       </InputAdornment>
        //         //     ),
        //         // }}
        //         IconComponent={()=>{return <KeyboardArrowDownIcon style={{ color: 'rgba(0, 0, 0, 0.75)' }}/>}}
        //         MenuProps={{
        //             PaperProps: {
        //                 style: {
        //                     maxHeight: 48 * 4.5 + 8, // This sets the maximum height of the dropdown menu
        //                     width: "20vw", // This sets the width of the dropdown menu to the available space
        //                 },
        //             },
        //         }}
        //     >
        //         {items && items.map((item, index) => (

        //             <MenuItem key={index} value={item}>
        //                 <a className="dropdown-item">{item.desc}</a>
        //             </MenuItem>
        //         ))}

        //     </Select>
        // </StyledFormControl>
        <Form.Select size={props.size} onChange={handleItemClick} aria-label="Default select example" disabled={props.isDisabled}
            value={
    (props?.selectedItem && selectedItem === '' 
        ? props.selectedItem 
        : selectedItem) !== '' 
        ? (props?.selectedItem && selectedItem === '' ? props.selectedItem : selectedItem)
        : "10000"}>
            {items && <option value="10000">Select Option</option>}
            {items && items?.map((item, index) => {
                return (<option key={index} value={index}> {item?.desc ? item.desc : item.attributeVal}
                </option>)
            })}

        </Form.Select>
    )
}
